const CLIENT_ID = 'outlook-integration-dev';
const APP_STORAGE_KEY = 'appcode';
const USER_STORAGE_KEY = 'user';
const COMPANY_STORAGE_KEY = 'companyId';
const PERSON_STORAGE_KEY = 'personId';
const INTEGRATION_TYPE = 'OUTLOOK';
const LANDING_PAGES = {
	MERCHANDISE: 'merchandiseLanding',
	EXPERIENCES: 'experiencesMarketplace'
};
export {
	CLIENT_ID,
	APP_STORAGE_KEY,
	USER_STORAGE_KEY,
	COMPANY_STORAGE_KEY,
	PERSON_STORAGE_KEY,
	INTEGRATION_TYPE,
	LANDING_PAGES
};